module.exports = __webpack_public_path__ + "media/images/home/main/aa/backup/8-7e1408f891c31f3d3ff88e899cb207d6.png";